require('normalize.css/normalize.css');
require('./main.scss');
require('./tableTestData1.json');
import css from './tabellen.scss';